module.exports = [{"text":"Bir tarlaya iki kürkü cırıq keçəl kor kirpi dadanmış. <n> Biri kürkü cırıq erkək keçəl kor kirpi digəri kürkü cırıq dişi keçəl kor kirpi. <n> Kürkü cırıq kişi keçəl kor kirpinin kürkünü kürkü cırıq dişi keçəl kor kirpinin kürkünə. <n> kürkü cırıq dişi keçəl kor kirpinin kürkünüdə kürkü cırıq erkək keçəl kor kirpinin kürkünə əlavə etmişlər.","id":"tw_az_1_1","title":"Kirpi"}]


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/tekerlemeler/tekerlemeler_az.json
// module id = Mg/5
// module chunks = 4